import React from 'react';
import bgImg from '../../assets/loginBg.png'

function FormBox({children}) {
  return (<>
      <div className="loginContainer">
        <div className='loginFlex'>
            <div className='loginFormBox'>
                {children}
            </div>
            <img src={bgImg} alt='Login-Image' className='loginBgImg' />
        </div>
      </div>
  </>)
}

export default FormBox